import { render, staticRenderFns } from "./PageTabRenderer.vue?vue&type=template&id=ca693e00&"
import script from "./PageTabRenderer.vue?vue&type=script&lang=js&"
export * from "./PageTabRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports